import { Expose, Transform, TransformPlainToClass } from 'class-transformer';

import { MenuPositionX, MenuPositionY } from '@angular/material/menu';

import { Default } from '@lib/common/decorators';

import { SnMenuConfig } from '../types';
import { SnMenuItem } from './menu-item.model';

export class SnMenu {
  @Expose()
  @Default('after')
  public positionX: MenuPositionX;

  @Expose()
  @Default('below')
  public positionY: MenuPositionY;

  @Expose()
  @Transform((value, data) => data.items.map(SnMenuItem.fromConfig))
  public items: SnMenuItem[];

  @TransformPlainToClass(SnMenu, { strategy: 'excludeAll' })
  public static fromConfig(config: SnMenuConfig): SnMenu {
    const data = Array.isArray(config) ? { items: config } : config;

    return data as SnMenu;
  }

  constructor() {}
}
